import { InputSearch } from "../../../../components/InputSearch";
import { FormSearchProducts } from "./Form";
import { NavContent } from "./style";
import Cart from "../../../../assets/img/Cart.svg";
import Close from "../../../../assets/img/Close.svg";
import { useContext } from "react";
import { UserContext } from "../../../../providers/UserContext";
import { CartContext } from "../../../../providers/CartContext";
import Searching2 from "../../../../assets/img/Searching2.svg";

export const Nav = () => {
  const { userLogout, showInputSearch, setShowInputSearch } =
    useContext(UserContext);
  const { setModal, cart } = useContext(CartContext);

  const handleClickCart = (e: React.MouseEvent<HTMLButtonElement>) => {
    setModal(true);
  };

  const productQuantity = cart.length;

  return (
    <NavContent>
      <button
        className="searching"
        onClick={() => {
          showInputSearch
            ? setShowInputSearch(false)
            : setShowInputSearch(true);
        }}
      >
        <img src={Searching2} alt="" />
      </button>
      {!showInputSearch && (
        <InputSearch>
          <FormSearchProducts />
        </InputSearch>
      )}
      <button className="buttonCart" onClick={handleClickCart}>
        <img src={Cart} alt="" />
        <div>
          <span>{productQuantity}</span>
        </div>
      </button>
      <button onClick={userLogout}>
        <img src={Close} alt="" />
      </button>
    </NavContent>
  );
};
